const is32BitInteger = num => (num | 0) === num

module.exports = is32BitInteger
